import React, { useState, useEffect } from 'react';
import { Alert } from 'react-bootstrap';

export interface SuccessMessageProps {
  message?: string,
  show?: boolean,
  timeout?: number,
  onDismiss?: () => void;
}

export const SuccessMessage: React.FC<SuccessMessageProps> = (props) => {

  const [visible, setVisible] = useState(true);

  //anytime the message changes, reset internal visible state
  useEffect(() => {
    setVisible(true);
    
    const timer = setTimeout(() => setVisible(false), props.timeout || 5000)
    //unsubscribe function if component unmounts early
    return () => clearTimeout(timer)
  }, [props.message])

  function handleDismiss() {
    setVisible(false);
    if (props.onDismiss) props.onDismiss();
  }

  if (!visible || !props.message) return null; 

  return (
    <Alert bsStyle="success" onDismiss={handleDismiss}>
      <p>{props.message}</p>
    </Alert>
  );
}

(SuccessMessage as any).displayName = 'SuccessMessage';